module.exports = __webpack_public_path__ + "static/media/9.3e41ad7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyebrowes/9.png
// module id = 1217
// module chunks = 0